module.exports = __webpack_public_path__ + "static/media/terms-of-use.142b2b84.pdf";